import React, { useState,useEffect } from 'react';
import axios from 'axios'
import {Redirect} from 'react-router-dom'
import {SpinnerLoaderCorso} from '../details/SpinnerLoader';
import Modal from 'react-modal';
import HeaderCorsi from './HeaderCorsi';

function compare(a, b) {
  if (a.position > b.position) return 1;
  if (b.position > a.position) return -1;
  return 0;
}
const customStyles = {
  content : {
    marginTop :"30px",
  }
};
function Corso(props) {
  const [selectedLession, setSelectedLession] = useState({lezione:null})
  const [listOfLession, setListOfLession] = useState(null)
  const [corso, setCorso] = useState(null)
  const [selectedModules, setSelectedModules] = useState(null)
  const [loggato, setLoggato] = useState(false)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(undefined)
  const [message, setMessage] = useState("")
  const [setTk, setSetTk] = useState(null)
  const [nomeDash, setNomeDash] = useState("")
  const [modalOpen, setModalOpen] = useState(false)
  const [recoverPassword, setRecoverPassword] = useState(false)
  const [clickedChangePassword, setClickedChangePassword] = useState(false)
  const [paidComplete, setPaidComplete] = useState(undefined)

  function selezionaModulo(modulo){
    if(corso && modulo.enable){
      if(selectedModules && modulo.id === selectedModules.id){
        setSelectedModules(null)
      }else{
        setSelectedModules(modulo)
      }
    }  
  }

  const updateLesson = (id, updatedProperties) => {
    setListOfLession(prevLessons =>
      prevLessons.map(lesson =>
        lesson.id === id ? { ...lesson, ...updatedProperties } : lesson
      )
    );
    setSelectedLession({...selectedLession, lezione:{...selectedLession.lezione, ...updatedProperties}})
  };

  const markAsInit = id => {
    updateLesson(id, { status: 1 });
  };

  const markAsCompleted = id => {
    updateLesson(id, { status: 2 });
  };

  function markLesson(lezione, status){
        //TODO: Da riscrivere questa roba in basso
        axios.post("/api/v1/updateLezioneStatus/",{corso_id:corso.id ,lezione_id:lezione.id, modulo_id:selectedModules.id,status:status, token:localStorage.getItem('tk')}).then((res)=>{
          if(status===1){
            markAsInit(lezione.id);
          }
          if(status === 2){
            markAsCompleted(lezione.id);
          }
        })
  }

  function selezionaLezione(lezione){
    if(lezione.enable){
      if(lezione.status === 0){
        markLesson(lezione, 1);
      }

      if(lezione.linkvideo_mp4){
        let data={}
        data["mp4"] = lezione.linkvideo_mp4
        axios.post("/api/v1/GetVideoBlob/",data).then(res=>{
          lezione.new_linkvideo_mp4 = lezione.linkvideo_mp4
          lezione.linkvideo_mp4=res.data.new_url
          setSelectedLession({...selectedLession, lezione:lezione})
        }).catch(error=>{
          console.log(error)
        })      
      }else{
        setSelectedLession({...selectedLession, lezione:lezione})
      }
    }
  }

  function toggleComplete(lezione){
    if(lezione.enable){
      markLesson(lezione, 2)
    }
    // if(lezione.enable && lezione.status === 1){
    //   markLesson(lezione, 2)
    //   markAsCompleted(lezione.id)
    // }else if(lezione.enable && lezione.status === 2){
    //   markLesson(lezione, 1)
    //   markAsInit(lezione.id)
    // }
  }

  function sendEmailRecoverPassword(e){
    e.preventDefault();
    setClickedChangePassword(!clickedChangePassword); 
    setMessage("Attendi completamento operazione...")
    let data={
      username:username,
      type:"request_change_password",
      gurl:props.match.params.slugcorso
    }
    axios.put("/api/v1/"+corso.id+"/user/",data).then((res)=>{
      if(res.data.msg){
        setMessage(res.data.msg)
      }
    }).catch(()=>{
      setMessage("Qualcosa è andato storto, contattami ad info@blackandwire.com se non riesci a proseguire")
      setClickedChangePassword(false)
    })
  }
  function setLezionePrecedente(){
    let previus = listOfLession.find(x=>x.position === Number(selectedLession.lezione.position)-1)
    let i = 2;
    while(previus && previus.hidden === true){
      previus = listOfLession.find(x=>x.position === Number(selectedLession.lezione.position)-i)
      i = i + 1;
    }
    if(previus) {
      selezionaLezione(previus)
    }
  }

  function setModuloSuccessivo(){
    let next = corso.modulo_set.find(x=>x.position === Number(selectedModules.position)+1)
    if(next) {
      setSelectedModules(next)
    }
  }

  function setLezioneSuccessiva(){
    let next = listOfLession.find(x=>x.position === Number(selectedLession.lezione.position) + 1)
    let i = 2;
    while(next && next.hidden === true){
      next = listOfLession.find(x=>x.position === Number(selectedLession.lezione.position) + i)
      i = i + 1;
    }
    if(next) {
      selezionaLezione(next)
    }else{
      setModuloSuccessivo()
    }
  }

  function formatISODate(isoDateStr) {
    // Crea un oggetto Date dalla stringa ISO
    const date = new Date(isoDateStr);

    // Estrai le componenti della data
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // I mesi sono indicizzati da 0 (Gennaio è 0)
    const year = date.getUTCFullYear();

    // Estrai le componenti dell'ora
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    // Combina le componenti nel formato desiderato
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}

  useEffect(() => {
    let slugcorso = props.match.params.slugcorso
    if(!props.match.params.slugcorso){
      slugcorso="progetto-gioielli"
    }

    setSetTk(localStorage.getItem('tk'))
    let header = {'token':localStorage.getItem('tk')}
    axios.get("/api/v1/corso/"+props.match.params.slugcorso+"/", {headers:header}).then((res)=>{
      setCorso(res.data)
      if(header){
        axios.get("/api/v1/"+res.data.id+"/user/",{headers:header}).then((res)=>{
          localStorage.setItem("tk",res.data.token)
          localStorage.setItem("name",res.data.name)
          
          setNomeDash(res.data.name)
          setSetTk(res.data.token)
          setLoading(true)
          setLoggato(true)
        }).catch((error)=>{
          window.location.href = "/corsi/login"
        })
      }
      })
  }, [])

  useEffect(() => {
    if(selectedModules){
      setListOfLession(null)
      axios.get("/api/v1/modulo/"+selectedModules.id+"/",{headers:{'token':setTk}}).then((res)=>{
        setListOfLession(res.data.lezione_set)
      }).catch((error)=>{
        setMessage("Errore, riprovare")
      })
    }
  }, [selectedModules])

  return (
      <>
      {loggato && setTk && corso ? 
        <div className="row height-forced" style={{margin:"-10px 0"}}>
          <Modal style={customStyles} isOpen={modalOpen}>
          <div>
            <div style={{textAlign:"right",marginTop:"-15px",padding:"10px 0"}} onClick={()=>{setModalOpen(!modalOpen)}}><b>X</b> chiudi</div>
            {corso.modulo_set.sort(compare).map((modulo,i)=>{
              return(
                <div key={i} style={{paddingBottom:"0"}}>
                  <b onClick={()=>{selezionaModulo(modulo)}}>
                    <h2 className="corso-menu-titolo-mobile" style={!modulo.enable ? {color:"lightgrey",position:"relative",cursor:"auto"} : {color:corso.color, position:"relative"}}>
                        {modulo.title} <i style={{fontSize:"15px",position:"absolute",top:"0px"}} className={!modulo.enable ? "fa fa-solid fa-lock" : null }></i>
                    </h2></b>
                    {!modulo.enable && modulo.open_after_date ? 
                      <div style={{textAlign:'center', fontSize:"12px",color:'grey'}}>
                        <>(Disponibile dal: <b>{formatISODate(modulo.open_after_date)}</b>)</>
                      </div>
                    :null}
                    {selectedModules && modulo.id === selectedModules.id ?
                    <div style={{borderTop:"1px solid",borderColor:corso.color}}>
                      <h5 className="corso-menu-sottotiolo" style={{color:corso.ButtonColor}}>{modulo.subtitle}</h5>
                      {!listOfLession ? 
                        <SpinnerLoaderCorso color={corso.ButtonColor} />
                      :null}
                      {listOfLession && listOfLession.sort(compare).map((lezione,i)=>{
                        return(
                          !lezione.hidden ?
                            lezione.enable ? 
                            <div key={i} style={{textAlign:"center"}} onClick={()=>{selezionaLezione(lezione);setModalOpen(!modalOpen)}}>
                              <div className="lezione-item" style={selectedLession.lezione && selectedLession.lezione.id === lezione.id ? 
                                {border:"2px solid ",borderColor:corso.color, color:corso.TextButtonColor,backgroundColor: corso.ButtonColor}:
                                {border:"2px solid", borderColor:corso.ButtonColor ,color:corso.TextButtonColor,backgroundColor: corso.ButtonColor ,cursor:"pointer"}}>
                                  {lezione.status == 0 ?
                                    <i style={{fontSize:"15px"}} className="far fa-circle"></i> 
                                  :lezione.status == 1 ? 
                                    <i style={{fontSize:"15px"}} className="far fa-dot-circle"></i> 
                                  : lezione.status == 2 ?
                                    <i style={{fontSize:"15px"}} className="far fa-check-circle"></i> 
                                  :null}
                                  <span style={{ marginLeft: "10px"}}>{lezione.title}</span>
                              </div>
                            </div>
                            :
                            <div key={i} style={{textAlign:"center"}}>
                            <div className="lezione-item" style={{color:"grey",position:"relative"}}>
                              <span style={{ marginLeft: "10px"}}>{lezione.title} <i style={{fontSize:"15px"}} className="fa fa-solid fa-lock"></i></span>
                            </div>
                          </div>
                        :null)
                      })}
                      </div>
                    :null}
                </div>
              )
            })}
          </div>               
          </Modal>

          <div className="col-lg-3 d-none d-lg-block left-corso">
            {corso.modulo_set.sort(compare).map((modulo,i)=>{
              return(
                <div key={i} style={{paddingBottom:"0"}}>
                  <b onClick={()=>{selezionaModulo(modulo)}}>
                    <h1 className="corso-menu-titolo" style={!modulo.enable ? {color:"lightgrey",position:"relative",cursor:"auto"} : {color:corso.color, position:"relative"}}>
                      {modulo.title}<i style={{fontSize:"15px",position:"absolute",top:"0px"}} className={!modulo.enable ? "fa fa-solid fa-lock" : null }></i></h1></b>
                      {!modulo.enable && modulo.open_after_date ? 
                      <div style={{textAlign:'center', fontSize:"12px",color:'grey'}}>
                        <>(Disponibile dal: <b>{formatISODate(modulo.open_after_date)})</b></>
                      </div>
                    :null}
                  {selectedModules && modulo.id === selectedModules.id ?
                   <div style={{borderTop:"3px solid",borderColor:corso.color}}>
                    <h5 className="corso-menu-sottotiolo" style={{color:corso.color}}>{modulo.subtitle}</h5>
                    {!listOfLession ? 
                      <SpinnerLoaderCorso color={corso.ButtonColor}/>
                    :null}
                    {listOfLession && listOfLession.sort(compare).map((lezione,i)=>{
                      return(
                        !lezione.hidden?
                          lezione.enable ? 
                          <div key={i} style={{textAlign:"center"}} onClick={()=>selezionaLezione(lezione)}>
                            <div className="lezione-item" style={selectedLession.lezione && selectedLession.lezione.id === lezione.id ? {border:"2px solid ",borderColor:corso.color, color:corso.TextButtonColor,backgroundColor: corso.ButtonColor,position:"relative"}:{border:"2px solid", borderColor:corso.ButtonColor ,color:corso.TextButtonColor,backgroundColor: corso.ButtonColor ,cursor:"pointer",position:"relative"}}>
                            {lezione.status == 0 ?
                              <i style={{fontSize:"15px"}} className="far fa-circle"></i> 
                            :lezione.status == 1 ? 
                              <i style={{fontSize:"15px"}} className="far fa-dot-circle"></i> 
                            : lezione.status == 2 ?
                              <i style={{fontSize:"15px"}} className="far fa-check-circle"></i> 
                            :null}
                              <span style={{ marginLeft: "10px"}}>{lezione.title} </span>
                            </div>
                          </div>
                          :
                          <div key={i} style={{textAlign:"center"}} onClick={()=>selezionaLezione(lezione)}>
                            <div className="lezione-item" style={{color:"grey",position:"relative"}}>
                              <span style={{ marginLeft: "10px"}}>{lezione.title} <i style={{fontSize:"15px"}} className="fa fa-solid fa-lock"></i></span>
                            </div>
                          </div>
                        :null
                      )
                    })}
                    </div>
                  :null}
                </div>
              )
            })}
          </div>
          <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12 right-corso" style={{marginTop:"-15px"}}>
            <div className="col-12" style={{paddingTop:"10px"}}>
              <div >
                <HeaderCorsi></HeaderCorsi>
                {paidComplete === false ? 
                  <Redirect to={"/corsi"} />
                :
              ""}
              </div>
              <hr/>
            </div>
            <div className="col-lg-4 d-block d-lg-none" style={{textAlign:"center"}}>
              <span onClick={()=>{setModalOpen(!modalOpen)}} className="button-newsletter" style={{fontSize:"22px",width:"100%",maxWidth:"50%",color:corso.TextButtonColor, padding:"5px",backgroundColor:corso.ButtonColor}}><i className="fas fa-bars"></i> MODULI</span>
              
            </div>
            <div className="row">
            {selectedLession.lezione === null ?
              <>
                <div className="col-12 corso-titolo">
                  <h1 style={{color:corso.color,fontSize:"60px",textAlign:"center"}}>{corso.title}</h1>
                </div>
                <div className="col-12">
                  <div className="col-12">
                  {/* <div style={{textAlign:"left",margin:"0 auto"}} dangerouslySetInnerHTML={{ __html: corso.subtitle}}></div> */}
                  </div>
                  <hr/>
                  <div className="col-12" style={{textAlign:"center",fontSize:"25px",marginTop:"20px"}}>Benvenut* <b>{nomeDash}</b></div>
                </div>
              </>
             :
             <div className="container" style={{textAlign:"center"}}>
               <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{margin:"0 auto",position:'relative'}}>
                <h3 className={"lezione-titolo"} style={{color:corso.color}}>{selectedLession.lezione.title}</h3>
                {selectedLession.lezione.status !== 2 ? 
                  <div style={{position:'relative', textAlign:'center'}}>
                    <button onClick={(e)=>toggleComplete(selectedLession.lezione)} className="span-bottone" style={{color:corso.text_button_color_next_prev, backgroundColor: corso.button_color_next_prev,marginRight:"15px"}}>
                        <><span style={{fontSize:"12px"}}>Segna come completato </span><i style={{fontSize:"15px"}} className="far fa-check-circle"></i></>
                      </button>
                  </div>
                :null}
                {selectedLession.lezione.title ? <span className={"lezione-titolo"}>{selectedLession.subtitle}</span>:null}
                {selectedLession.lezione.link_vimeo ? 
                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                      <iframe title="Giorgia Graziani - Corso" 
                        src={selectedLession.lezione.link_vimeo}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                        }} 
                        frameborder="0"    
                        allow="autoplay; fullscreen; picture-in-picture"
                        mozallowfullscreen webkitallowfullscreen allowfullscreen>  
                      </iframe>
                    </div>
                : selectedLession.lezione.linkvideo_mp4 || selectedLession.lezione.linkvideo_webm ? 
                  <div style={{marginTop:"15px"}}>
                    <video key={selectedLession.lezione.linkvideo_webm ? selectedLession.lezione.linkvideo_webm : selectedLession.lezione.new_linkvideo_mp4} 
                    controls style={{maxHeight:"600px",width:"100%"}} controlsList="nodownload" poster={selectedLession.lezione.videoimage ? selectedLession.lezione.videoimage :""}>
                      {selectedLession.lezione.new_linkvideo_mp4 ? <source src={selectedLession.lezione.new_linkvideo_mp4} type="video/mp4" /> : null}
                      {selectedLession.lezione.linkvideo_webm ? <source src={selectedLession.lezione.linkvideo_webm} type="video/webm" /> : null}
                      {selectedLession.lezione.linkvideo_mp4 ? <source src={selectedLession.lezione.linkvideo_mp4} type="video/mp4" /> : null}
                      
                      Sorry, your browser doesn't support embedded videos.
                    </video>
                  </div> 
                : null}
                {selectedLession.lezione.file ? 
                  <div className={!selectedLession.lezione.linkvideo_mp4 && !selectedLession.lezione.linkvideo_webm ? "padding-pdf-50" : "padding-pdf-15"}>
                    <a href={selectedLession.lezione.file} className="linkpdf" target="_blank" rel="noopener noreferrer">
                      <span className="lezione-item" style={{padding:"15px",backgroundColor:"#053861", color:"#FFFFFF"}}>Scarica il documento in pdf &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fas fa-arrow-down"></i></span></a>
                  </div> 
                : null}
                <div style={{textAlign:"center"}}>
                <div dangerouslySetInnerHTML={{ __html: selectedLession.lezione.descrizione}}/>
                </div>
              </div>
              <div className="row button-lezioni-arrow">
                <div className="col-6">
                  {selectedLession.lezione.position > 0 ?
                    <span className="span-bottone" onClick={()=>setLezionePrecedente()} style={{color:corso.text_button_color_next_prev, backgroundColor: corso.button_color_next_prev}}>Lezione precedente</span>
                  :null}
                  </div>
                <div className="col-6"><span className="span-bottone" onClick={()=>setLezioneSuccessiva()} style={{color:corso.text_button_color_next_prev, backgroundColor: corso.button_color_next_prev}}>Lezione successiva</span></div>
              </div>
            </div>}
          </div>
          </div>
      </div>
      :null}
     </>
  );
}

export default Corso;
